module.exports = __webpack_public_path__ + "img/logo.39a22884.png";